import React from "react";
import FilterComponent from "../../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../../CoreComponents/FilterModalComponent";
import DayBasisSwitch from "../../../CoreComponents/DayBasisSwitch";

function RestaurantOrderHistory({
  filter,
  setfilter,
  basis,
  setBasis,
  reportNext,
  reportPrev,
  branchAmounts,
  orderReportSummary,
  handleReportNext,
  handleReportPrev,
  getOrderReportSummary,
  getWallet,
  showMessage,
}) {
  return (
    <div
      className="mt-4"
      style={{ backgroundColor: "white", borderRadius: 20 }}
    >
      <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0 row">
        <div className="mr-auto pr-3">
          <h4 className="text-black fs-20">
            Report Summary{" "}
            <span className="text-color-primary">
              {filter.from_date && filter.to_date
                ? `(${new Date(
                    filter.from_date
                  ).toLocaleDateString()} - ${new Date(
                    filter.to_date
                  ).toLocaleDateString()})`
                : "(Last 30 days)"}
            </span>
          </h4>
        </div>
        <FilterComponent
          handleNext={handleReportNext}
          handlePrev={handleReportPrev}
          next={reportNext}
          prev={reportPrev}
          filterButtonName={"Filter"}
          type="restaurant_page_report"
        />
      </div>
      <div className="card-body" style={{ width: "100%" }}>
        <div className="mb-3">
          <DayBasisSwitch value={basis} onChange={setBasis} />
        </div>
        <div className="basic-form mb-2">
          <div className="card-body ">
            <div className="row align-items-center">
              <div className="col-sm-4">
                <div className="p-3 border rounded">
                  <h6 className="fs-17 text-center mb-1">Pending</h6>
                  <h3 className="fs-30 text-black text-center font-w600 mb-1">
                    <span className="text-color-primary">₹</span>{" "}
                    {branchAmounts.pending}
                  </h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="p-3 border rounded">
                  <h6 className="fs-17 text-center mb-1">Processing</h6>
                  <h3 className="fs-30 text-black text-center font-w600 mb-1">
                    <span className="text-color-primary">₹</span>{" "}
                    {branchAmounts.processing}
                  </h3>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="p-3 border rounded">
                  <h6 className="fs-17 text-center mb-1">Completed</h6>
                  <h3 className="fs-30 text-black text-center font-w600 mb-1">
                    <span className="text-color-primary">₹</span>{" "}
                    {branchAmounts.completed}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 row justify-content-center">
          <div className="row justify-content-center align-content-center">
            <b className="text-center fs-20 text-color-primary">
              Order Transactions
            </b>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="table-responsive rounded card-table">
            <div id="example5_wrapper" className="dataTables_wrapper no-footer">
              <table
                className="table border-no order-table mb-2 table-responsive-sm dataTablesCard"
                id="example5"
              >
                <thead>
                  <tr>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Order ID</th>
                    <th>Amount</th>
                    <th>Payment transaction status</th>
                  </tr>
                </thead>
                <tbody>
                  {orderReportSummary.map((item) => (
                    <tr key={item.id || item.order} className="alert alert-dismissible border-1">
                      <td>
                        {new Date(item.created_time).toLocaleDateString()}
                      </td>
                      <td>
                        {new Date(item.created_time).toLocaleDateString()}
                      </td>
                      <td>{item.order}</td>
                      <td>{item.amount_to_restaurant}</td>
                      <td>{item.to_branch_tstatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <FilterModalComponent
        heading={"Filter report"}
        fromDateValue={filter.from_date.slice(0, 10)}
        fromDateChange={(e) => {
          setfilter({
            ...filter,
            from_date: e.target.value + " 00:00:00",
          });
        }}
        toDateValue={filter.to_date.slice(0, 10)}
        toDateChange={(e) => {
          setfilter({
            ...filter,
            to_date: e.target.value + " 00:00:00",
          });
        }}
        clearFilter={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
        submitFilter={(e) => {
          e.preventDefault();
          if (filter.from_date) {
            if (!filter.to_date) {
              showMessage(
                "From and To dates are mandatory",
                "danger",
                "Error!",
                "top",
                "top-right",
                0
              );
              return;
            }
          }
          if (filter.to_date) {
            if (!filter.from_date) {
              showMessage(
                "From and To dates are mandatory",
                "danger",
                "Error!",
                "top",
                "top-right",
                0
              );
              return;
            }
          }
          getOrderReportSummary();
          getWallet();
        }}
      >
        <div className="col-lg-6">
          <div className="form-group">
            <label className="text-black font-w600">
              Payment transaction status <span className="required"></span>
            </label>
            <select
              value={filter.payment_transaction_status}
              className="form-control form-control-lg"
              onChange={(e) =>
                setfilter({
                  ...filter,
                  payment_transaction_status: e.target.value,
                })
              }
            >
              <option value="">All</option>
              <option value="PENDING">PENDING</option>
              <option value="PROCESSING">PROCESSING</option>
              <option value="COMPLETED">COMPLETED</option>
              <option value="DECLINED">DECLINED</option>
            </select>
          </div>
        </div>
      </FilterModalComponent>
    </div>
  );
}

export default RestaurantOrderHistory;
